import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import { ConstantService } from '@app/_services/constant.service';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-channel-details',
    templateUrl: './channel-details.component.html',
    styleUrls: ['./channel-details.component.css'],
    standalone: false
})
export class ChannelDetailsComponent implements OnInit {

	@Input() resRevByDay: any = [];

	constructor(
		public messageService: MessageService,
		public reportService: ReportService,
		private constantService: ConstantService,) { }

	gridApi: GridApi;
	columnApi: ColumnApi;

	// ag-grid columns
	occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
	occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;


	autoGroupColumnDef = {
		headerName: 'Property',
		cellRendererParams: {
			suppressCount: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};

	columnDefs: ColDef[] = [
		//Groups
    	// { headerName: 'Channel Picture', field: 'refSrcId', rowGroup: true, hide: true, width: 60, sortable: false, autoHeight: true,
		//  cellRenderer: params => this.displayChannelPicture(params) },
		 { headerName: 'Channel', field: 'refSrcId', rowGroup: true, hide: true,
		cellRenderer: params => this.displayChannelName(params)},
		{ headerName: 'Sale Year', field: 'saleYear', rowGroup: true, hide: true, valueGetter: this.getYearFromDate },
		// { headerName: 'Sale Month', field: 'saleMonth', rowGroup: true, hide: true, valueGetter: this.getMonthFromDate },
		{
			headerName: 'Sale Month', field: 'saleMonth', rowGroup: true, hide: true, valueGetter: this.getMonthFromDate,
			 comparator: (valueA, valueB) => {
				const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
					'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
				// sorts 'months' in chronological order
				return months.indexOf(valueA) - months.indexOf(valueB);
			},
		},
		{ headerName: 'Property', field: 'propertyCode', rowGroup: true, hide: true}, 
		{ headerName: 'Sale Day', field: 'saleDayOfMonth', rowGroup: true, hide: true, sortable: true, 
		sort: 'asc', valueGetter: this.getDayFromDate,
		 comparator: (valueA, valueB, nodeA, nodeB, isDescending) => valueA - valueB},
		//Columns
		{ headerName: 'Room Rate', field: 'revRoomRateNetTTL', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
	];

	columnDefs2: ColDef[] = [
		// //Groups
		{
			field: 'saleMonth', pivot: true, pivotComparator: (valueA, valueB) => {
				const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
					'August', 'September', 'October', 'November', 'December'];
				// sorts 'months' in chronological order
				return months.indexOf(valueA) - months.indexOf(valueB);
			},
		},
		{ headerName: 'Night Rate', field: 'revRoomRateNetPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Number of Nights', field: 'numNtsTTL', aggFunc: 'sum' },
    	// { headerName: 'Channel Picture', field: 'refSrcId', rowGroup: true, hide: true, width: 60, sortable: false, autoHeight: true,
		//  cellRenderer: params => this.displayChannelPicture(params) },
		 { headerName: 'Channel', field: 'refSrcId', rowGroup: true, hide: true,
		cellRenderer: params => this.displayChannelName(params)},
		 { headerName: 'Property', field: 'propertyCode', rowGroup: true, hide: true},
	];



	gridOptions: GridOptions = {
		rowData: this.resRevByDay,
		columnDefs: this.columnDefs,
		pagination: true,
		rowSelection: 'single',
		suppressAggFuncInHeader: true,

		// EVENTS
		// Add event handlers
		onRowClicked: event => console.log('A row was clicked'),
		onColumnResized: event => console.log('A column was resized'),
		onGridReady: event => console.log('The grid is now ready'),

		// CALLBACKS
		getRowHeight: (params) => 25,

		aggFuncs: {
			// this overrides the grids built-in avg function
			'showArrivalDate': params => {
				console.log(JSON.stringify(params.values));
				if (params.values[1]) {
					return params.values[1].checkInDate;
				}
			},
		}
	}

	gridOptions2: GridOptions = {
		rowData: this.resRevByDay,
		columnDefs: this.columnDefs2,
		pagination: true,
		rowSelection: 'single',
		suppressAggFuncInHeader: true,

		// EVENTS
		// Add event handlers
		onRowClicked: event => console.log('A row was clicked'),
		onColumnResized: event => console.log('A column was resized'),
		onGridReady: event => console.log('The grid is now ready'),

		// CALLBACKS
		getRowHeight: (params) => 25,

		aggFuncs: {
			// this overrides the grids built-in avg function
			'showArrivalDate': params => {
				console.log(JSON.stringify(params.values));
				if (params.values[1]) {
					return params.values[1].checkInDate;
				}
			},
		}
	}

	// forms
	formLoading = false;


	// to hold the current search
	currentSearchForm: any;


	// data
	resRevMaster: any[];
	resRevMasterByDay: any[];
	resRevTotal: any[];
	resRevTotalByDay: any[];
	resRevTotalByMonth: any[];
	resRevTotalByYear: any[];


	// search defaults
	defaultStartDate: Date
	defaultEndDate: Date
	defaultDevelopmentStatuses: any;
	defaultShortTermRentalIds: any;

	displayChannelPicture (params: any) {
		if (params.value) {
			return "<img style='height: 25px; width: 60px' src='"+this.constantService.refSrcImages.find(function(item) { return item.value == params.value })?.imgurl+"'>"	
		}
	};

	displayChannelName (params: any) {
		if (params.value) {
			return this.constantService.refSrcImages.find(function(item) { return item.value == params.value })?.label;
		}
	};

	getRentedPercent(params: any) {
		return (params.data.numNightsTTL / params.data.numNtsInMonthTTL)
	}

  onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}

	getNtsAvailToRent(params: any) {
		let ntsAvailToRent = new Date(moment(params.data.date).year(), moment(params.data.date).month(), 0).getDate() - (params.data.numNtsOwnerTTL + params.data.numNtsOwnerGuestTTL + params.data.numNtsMaintTTL);
		console.log('ntsAvailToRent' + ntsAvailToRent);
		return ntsAvailToRent;
	}

	getDaysInMonth(month: number, year: number) {
		console.log('days ' + new Date(year, month, 0).getDate());
		return new Date(year, month, 0).getDate();
	}


	getYearFromDate(params: any) {
		return moment(params.data.saleDate).format('YYYY')
	}

	getMonthFromDate(params: any) {
		return moment(params.data.saleDate).format('MMM');
	}

	getDayFromDate(params: any) {
		if(params && params.data && params.data.saleDayOfMonth) {
			return Number.parseInt(params.data.saleDayOfMonth);
		}
		// return Number.parseInt((moment(params.data.saleDate).format('DD')));
	}



	getGuestName(params: any) {
		if (params.data) {
			return moment(params.data.checkInDate).format('MM/DD/YY') + ' - ' + moment(params.data.checkOutDate).format('MM/DD/YY') + '   #' + params.data.developmentId + ' ' + params.data.guestLastName;
		}
		return '';
	}

	getStayDates(params: any) {
		if (params.data) {
			return params.data.checkInDate + ' - ' + params.data.checkInDate;
		}
		return '';
	}

	currencyCellRendererUSD(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		return inrFormat.format(params.value);
	}

	percentCellRenderer(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'percent',
			minimumFractionDigits: 1,
			maximumFractionDigits: 1
		});
		return inrFormat.format(params.value);
	}

	fullDateCellRendererUSD(params: any) {
		if (params.data && params.value) {
			return moment(params.value).format('MM/DD/YY')
		}
	}

	ngOnInit(): void {
		this.defaultStartDate = new Date();
		// this.defaultStartDate = new Date(this.defaultStartDate.getFullYear()-4, this.defaultStartDate.getMonth(), 1);
		this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), 0, 1); // jan 1
		this.defaultEndDate = new Date();
		this.defaultEndDate = new Date(this.defaultEndDate.getFullYear(), 12, 0);

		this.defaultDevelopmentStatuses = ['OP', 'OO', 'OG'];
		this.defaultShortTermRentalIds = [1];

		// ag-grid
		this.gridOptions.rowData = this.resRevByDay;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
		this.gridOptions.pagination = true;
		this.gridOptions.suppressAggFuncInHeader = true;
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;

		// Pivot
		// this.gridOptions.pivotMode = true;
		// this.gridOptions.pivotColumnGroupTotals= 'before';
		// this.gridOptions.pivotRowTotals = 'before';

		// Footer
		this.gridOptions.groupIncludeFooter = true;
		this.gridOptions.groupIncludeTotalFooter = true;

		// https://www.ag-grid.com/javascript-data-grid/column-sizing/
		// this.gridOptions.suppressColumnVirtualisation = true;
	}

	ngAfterViewInit(): void {
		(this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
	}

	onGridReady(grid: any): void {
		this.gridApi = grid;
		this.columnApi = grid.columnApi;
		// if(this.resRevByDay) {
		// 	const colDefs = (this.gridOptions as any).api.getColumnDefs();
		// 	colDefs.length=0;
		// 	const keys = Object.keys(this.resRevByDay[0])
		// 	console.log(keys);
		// 	keys.forEach(key => {
		// 		colDefs.push({field : key})
		// 	});
		// 	(this.gridOptions as any).api?.setColumnDefs(colDefs);
			
		// 	// add the data to the grid
			
		// 	(this.gridOptions as any).api.setRowData(this.resRevByDay);
		// }

	}
	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 5000);
	}

}
